<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <h6>Root Cause Analysis</h6>
      <hr />
      <b-form-group>
        <b-form-textarea v-model="model.rmaInspection_RootCauseAnalysis" />
      </b-form-group>
    </div>
    <div class="list-group-item mb-2">
      <h6>Responsibility</h6>
      <hr />
      <b-form-group label="Sales" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.rmaInspection_ResponsibilitySales"></b-form-input>
      </b-form-group>
      <b-form-group label="Supplier" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.rmaInspection_ResponsibilitySupplier"></b-form-input>
      </b-form-group>
      <b-form-group label="Shipping" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.rmaInspection_ResponsibilityShipping"></b-form-input>
      </b-form-group>
      <b-form-group label="Customer" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.rmaInspection_ResponsibilityCustomer"></b-form-input>
      </b-form-group>
      <b-form-group label="Other" label-cols-sm="1">
        <b-form-textarea class="col-4" v-model="model.rmaInspection_ResponsibilityOther"></b-form-textarea>
      </b-form-group>
    </div>
    <div class="list-group-item mb-2">
      <div class="row">
        <div class="col-md-11">
          <h6>Documents and Images</h6>
        </div>
        <div class="col-md-1">
          <button class="btn btn-primary pull-right" @click="onShowModal"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <hr />
      <b-list-group class="scroll" flush>
        <div class="list-item" v-for="list in documentsLists.filter(x => x.partId == rmaLinePartId && x.partInspectionLineId == inspectionDetails.id && x.customerRMALineId == inspectionDetails.rmaLineId)" :key="list.id">
          <i :class="'fa ' + (list.type.includes('image/') ? 'fa-image' : 'fa-file') + ' mr-2'"></i>
          {{ list.filename }}
          <!--<i class="fa fa-eye ml-2 hover-btn" v-if="(list.type.includes('image/') || list.type.includes('pdf'))" @click="onView(list)"></i>-->
          <i class="fa fa-trash ml-2 hover-btn" @click="onDeleteFile(list)"></i>
        </div>
      </b-list-group>
    </div>


    <b-modal id="upload-rmarca-document" ref="upload-rmarca-document" size="sm" centered :title="'Upload Document'"
             :ok-title="isUploading ? 'Uploading' : 'Upload'" :ok-disabled="isUploading" @ok="onUploadFile" @show="filesUpload = []">
      <b-form-group label="Type">
        <b-form-select v-model="documentCategoryIdSelected">
          <option
            v-for="documentCategory in sortSelect(documentCategories)"
            :key="documentCategory.id"
            :value="documentCategory.id"
          >{{ documentCategory.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-file
        multiple
        v-model="filesUpload"
        :file-name-formatter="formatNames"
        :accept="fileTypes"
      ></b-form-file>
    </b-modal>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'rmaRcaResponsibility',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
    rmaLinePartId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      model: {
        rmaInspection_RootCauseAnalysis: this.inspectionDetails[FIELDS.RMA_INSPECTION__ROOT_CAUSE_ANALYSIS] || '',
        rmaInspection_ResponsibilitySales: this.inspectionDetails[FIELDS.RMA_INSPECTION__RESPONSIBILITY_SALES] || '',
        rmaInspection_ResponsibilitySupplier: this.inspectionDetails[FIELDS.RMA_INSPECTION__RESPONSIBILITY_SUPPLIER] || '',
        rmaInspection_ResponsibilityShipping: this.inspectionDetails[FIELDS.RMA_INSPECTION__RESPONSIBILITY_SHIPPING] || '',
        rmaInspection_ResponsibilityCustomer: this.inspectionDetails[FIELDS.RMA_INSPECTION__RESPONSIBILITY_CUSTOMER] || '',
        rmaInspection_ResponsibilityOther: this.inspectionDetails[FIELDS.RMA_INSPECTION__RESPONSIBILITY_OTHER] || ''
      },
      filesUpload: [],
      documentCategoryIdSelected: 0,
      fileTypes: [
        '.txt',
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.csv',
        '.ppt',
        '.pptx',
      ].join(', '),
      isUploading: false,
      imageCategoryId: 202,
      acceptedView: [
        'application/pdf',
        '.pdf'
      ]
    };
  },
  computed: {
    ...mapGetters('lookup', [
      'documentCategories',
    ]),
    ...mapGetters('parts', [
      'documentsLists',
    ]),
    imagesList() {
      //
      return this.documentsLists.filter(x => x.partId == this.rmaLinePartId && x.customerRMALineId == this.inspectionDetails.rmaLineId && x.partInspectionLineId == this.inspectionDetails.id && x.documentCategoryId == this.imageCategoryId && x.type.includes('image/')).map(image => ({
        id: image.id,
        name: image.filename,
        url: image.virtualPath
      }));
    }
  },
  methods:{
    ...mapActions('parts', [
      'uploadDocuments',
      'getDocuments',
      'deleteDocument'
    ]),
    onShowModal() {
      this.$refs['upload-rmarca-document'].show();
    },
    async onGetFiles() {
      let filtersObj = `{partId: ${this.rmaLinePartId}`
      filtersObj += `, customerRMALineId: ${this.inspectionDetails.rmaLineId}`
      filtersObj += `, partInspectionLineId: ${this.inspectionDetails.id}`
      filtersObj += `}`

      await this.getDocuments(filtersObj);
    },
    onUploadFile: async function(e) {
      if (this.filesUpload.length > 0 && this.documentCategoryIdSelected > 0) {
        try {
          this.isUploading = true;
          let formData = new FormData();
          this.filesUpload.forEach(element => {
            formData.append('files[]', element, element.name);
          });
          formData.append('partId', this.rmaLinePartId);
          formData.append('documentCategoryId', this.documentCategoryIdSelected);
          formData.append('partInspectionLineId', this.inspectionDetails.id);
          formData.append('customerRMALineId', this.inspectionDetails.rmaLineId);

          e.preventDefault();

          const result = await this.uploadDocuments(formData);
          this.$refs['upload-rmarca-document'].hide();
          this.isUploading = false;
          if (result.status == 200)
            this.$snotify.success('Upload successful', 'Upload');

          this.onGetFiles();
        } catch (e) {
          this.isUploading = false;
        }
      } else {
        e.preventDefault();
        if(this.documentCategoryIdSelected === 0){
          alert('Please Select Document Type');
        }else {
          alert('No File Uploaded');
        }
        return;
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    onView(file) {
      if (file.type.includes('image/')) {
        const ndx = this.imagesList.findIndex(x => x.id == file.id);
        if(ndx !== -1) {
          this.$imageViewer.index(ndx);
          this.$imageViewer.show();
        }
      } else {
        window.open(process.env.VUE_APP_API_URL + file.virtualPath, '_blank');
      }
    },
    async onDeleteFile(file) {
      const deleteConfirmed = await this.openConfirmBox({
        message:'Are you sure you would like to delete the file ' + file.filename + '?',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
      });
      if (deleteConfirmed) {
        const result = await this.deleteDocument(file.id);
        if (result.status==200) {
          this.onGetFiles();
          this.$snotify.success('Delete successful', 'Delete');
        }
      }
    }
  },
  mounted() {},
};
</script>